import { styled } from '@mui/material/styles';
import { RESULT_LEGACY_CONTENT_SIZE } from '@/constant';

export const ResultContentContainer = styled('div')(({ theme }) => ({
    width: `${RESULT_LEGACY_CONTENT_SIZE.width}px`,
    height: `${RESULT_LEGACY_CONTENT_SIZE.height}px`,

    backgroundColor: '#EDDCCC',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    borderRadius: 8,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
}));
